// extracted by mini-css-extract-plugin
export default {"wrapper__cards":"stayle_wrapper__cards__UNL1J"};